export const auLinks = {
  footerLegalLinks: [
    {
      text: "Terms & Conditions",
      href: "https://assets.latitudefinancial.com/terms-and-conditions/terms-webform-au.pdf",
    },
    {
      text: "Privacy and Credit Reporting Policy",
      href: "https://www.latitudefinancial.com.au/privacy/",
    },
    {
      text: "Security",
      href: "https://www.latitudefinancial.com.au/security/",
    },
    {
      text: "Complaints",
      href: "https://www.latitudefinancial.com.au/complaints/",
    },
    {
      text: "Financial Hardship",
      href: "https://www.latitudefinancial.com.au/hardship/",
    },
  ],
  termsAndConditions:
    "https://assets.latitudefinancial.com/terms-and-conditions/terms-webform-au.pdf",
  privacyCreditReportingPolicy: "https://www.latitudefinancial.com.au/privacy/",
};

export const nzLinks = {
  footerLegalLinks: [
    {
      text: "Terms & Conditions",
      href: "https://assets.latitudefinancial.com/terms-and-conditions/terms-webform-nz.pdf",
    },
    {
      text: "Privacy and Credit Reporting Policy",
      href: "https://www.gemfinance.co.nz/privacy/",
    },
    {
      text: "Security",
      href: "https://www.gemfinance.co.nz/security/",
    },
    {
      text: "Complaints",
      href: "https://www.gemfinance.co.nz/complaints/",
    },
    {
      text: "Financial Hardship",
      href: "https://www.gemfinance.co.nz/hardship/",
    },
    {
      text: "Prescribed Statement Disclosure",
      href: "https://assets.latitudefinancial.com/legals/product-disclosure-statements/nz/pds.pdf",
    },
  ],
  aboutUs: "https://www.gemfinance.co.nz/about-us/",
};
